// assets/section-blog-gallery.js

document.addEventListener('DOMContentLoaded', function() {
  
  const productWrappers = document.querySelectorAll('.product.js-product[data-product-handle^="blog-"]');

  productWrappers.forEach(wrapper => {
    // 要素の取得
    const mainEl = wrapper.querySelector('.blog-gallery__main.swiper');
    const thumbsEl = wrapper.querySelector('.blog-gallery__thumbs.swiper');

    if (!mainEl || !thumbsEl) {
      console.error('Blog Gallery: Main or Thumbs element not found in wrapper:', wrapper);
      return;
    }

    const thumbsSwiper = new Swiper(thumbsEl, {
      direction: 'horizontal',
      freeMode: true,
      slidesPerView: 'auto',
      spaceBetween: 10,
      watchSlidesProgress: true,
      mousewheel: true,
      
      // アクティブなスライドを中央にする設定
      centeredSlides: true,
      centeredSlidesBounds: true, 
      
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
      
      // 初期化後の補正処理 (product-media-gallery.js から移植)
      on: {
        afterInit: (swiper) => {
          // 最初のスライドに移動
          if (swiper.activeIndex !== 0) swiper.slideTo(0);
          // ラッパー要素の監視
          const swiperWrapper = swiper.wrapperEl;
          
          const observer = new MutationObserver(() => {
            if (
              swiperWrapper.hasAttribute('style') &&
              swiperWrapper.style?.transform &&
              swiperWrapper.style?.transform !== 'translate3d(0px, 0px, 0px)'
            ) {
              swiperWrapper.style.transform = 'translate3d(0px, 0px, 0px)';
            } 
            // 正常にリセットされたら監視を終了する (無限ループ防止)
            else if (
              swiperWrapper.hasAttribute('style') &&
              swiperWrapper.style?.transform &&
              swiperWrapper.style?.transform === 'translate3d(0px, 0px, 0px)'
            ) {
              setTimeout(() => {
                if (
                  swiperWrapper.hasAttribute('style') &&
                  swiperWrapper.style?.transform &&
                  swiperWrapper.style?.transform === 'translate3d(0px, 0px, 0px)'
                ) {
                  observer.disconnect();
                }
              }, 500);
            }
          });

          // 属性の変化を監視開始
          observer.observe(swiperWrapper, { attributes: true });
        }
      }
    });

    const mainSwiper = new Swiper(mainEl, {
      navigation: {
        nextEl: mainEl.querySelector('.swiper-button-next'),
        prevEl: mainEl.querySelector('.swiper-button-prev'),
      },
      autoHeight: false, 
      thumbs: {
        swiper: thumbsSwiper,
      },
      wrapperClass: 'swiper-wrapper',
      slideClass: 'swiper-slide',
    });

    mainSwiper.on('slideChange', () => {
      thumbsSwiper.slideTo(mainSwiper.activeIndex);
    });
  });
});